import request from './request'

/**
 * 获取短信验证码
 * @param {string} userId 用户ID
 */
export function getSmsCode(data) {
  return request.get('/win_api_smsSend.php', {
    params: data
  })
}

/**
 * 获取短信验证码状态
 * @param {} data 参数对象
 */
export function getCodeInfo(data) {
  return request.get('/win_api_smsInfoCheck.php', {
    params: data
  })
}

/**
 * 获取权限认证状态
 * @param {} data 参数对象
 */
export function getPermission(data) {
  return request.get('/win_api_getPermission3.php', {
    params: data
  })
}

/**
 * 用来验证购买时，验证获取积分的，只要有认证permission记录
 * @param {} data 参数对象
 */
export function getPermissionPoint(data) {
  return request.get('/getPermissionPoint.php', {
    params: data
  })
}

export function getSms(userId) {
  return request.get('/user/info', {
    params: {
      userId
    }
  })
}
